import ReactDOM from "react-dom/client";
import "./App.css";
import "./index.css";
import App from "./App";
import reportWebVitals from './reportWebVitals'
import { Provider } from "react-redux";
import { store } from "./Config/store";
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>

);

reportWebVitals();
